export default {
	Slide: 'חִידָה',
	Puzzle: 'חִידָה',
	'The puzzle is open!': 'הפאזל פתוח!',
	'Congratulations!': 'מזל טוב!',
	'You get it': 'אתה מקבל',
	'You get the task done': 'אתה מסיים את המשימה',

	'Show all blocked': 'הצג הכל חסום',

	Author: 'מְחַבֵּר',
	'Reset filters': 'אפס מסננים',

	Blocked: 'חָסוּם',
	Unlocked: 'לא נעול',

	'Block student': 'תלמיד חסום',

	Change: 'שינוי',
	'The student is blocked': 'התלמיד חסום',
	'The student is blocked with a new price': 'הסטודנט נחסם עם מחיר חדש',
	'To unlock this student, go to the "Restore" section':
		'כדי לבטל את הנעילה של תלמיד זה, עבור לקטע "שחזור".',

	'Before blocking, you can change the price for the student':
		'לפני החסימה ניתן לשנות את המחיר לסטודנט',

	'First month cost': 'מחיר לחודש אחד',

	"You cannot do homework in the student's platform":
		'אתה לא יכול לעשות שיעורי בית בפלטפורמה של התלמיד',

	'Restore the student ?': 'לשחזר את התלמיד?',
	'Restore the teacher ?': 'לשחזר את המורה?',
	'Restore the franchise ?': 'לשחזר את הזיכיון?',

	'Transition to 50': 'מעבר ל-50',
	'Transition to 100': 'מעבר ל-100',

	fifty: 'מעבר ל-50',
	hundred: 'מעבר ל-100',

	Faces: 'פרצופים',

	Heroes: 'גיבורים',
	Clothes: 'בגדים',
	Backgrounds: 'רקעים',
	Souvenirs: 'מזכרות',

	'Coming soon': 'בקרוב',

	'Wow! Congratulations, you have successfully purchased this product.':
		'וואו! מזל טוב, רכשת בהצלחה את המוצר הזה.',
	'You can view all your purchases in the "Purchased" section':
		'אתה יכול לראות את כל הרכישות שלך בסעיף "נרכש".',

	'Your savings': 'החסכונות שלך',
	'You can spend them on something interesting!':
		'אתה יכול לבזבז אותם על משהו מעניין!',

	'A student with this email address already exists':
		'משתמש עם דוא"ל כזה כבר קיים',

	'User with such email already exists': 'משתמש עם דוא"ל כזה כבר קיים',
	'Year of birth': 'שנת לידה',
	Registration: 'הַרשָׁמָה',
	'Surname of parents': 'שם משפחה של ההורים',
	School: 'בית ספר',
	'Field is required': 'שדה נדרש',
	'Select age': 'בחר גיל',
	'No such teacher for this year': 'אין מורה כזה השנה',
	'User with such phone number already exists':
		'משתמש עם מספר טלפון כזה כבר קיים',
	'You are successfully registered': 'נרשמת בהצלחה',
	'Max length 20 chars': 'אורך מקסימלי 20 תווים',

	'INTERNATIONAL SCHOOL': 'בית ספר בינלאומי',
	'Mental Arithmetic': 'חשבון נפש',
	'For children aged 5-14.': 'לילדים בגילאי 5-14.',
	'Sign up for a trial lesson': 'הירשם לשיעור ניסיון',
	'Parents name': 'שם ההורים',
	'Childs age': 'גיל הילד',
	Country: 'מדינה',
	'Sign up': 'הירשם',
	'Open offer agreement': 'הסכם הצעה פתוחה',

	export: 'יְצוּא',

	wrong: 'לא נכון',
	right: '‎נכון',
	match: {
		addition: '‎שורף אחר',
		multiply: '‎כפל',
		divide: '‎חילוק	',
		abacus_random: 'אבקוס אקראי',
		anzan: '‎אנזן',
		negative: 'מספרים שליליים',
		column: 'עמודות',
	},
	timeIsOver: 'הזמן נגמר',
	timer: 'שָׁעוֹן עֶצֶר',
	'Back to Lessons': 'לרשימת חזרה שיעורים',
	'Create Lesson': 'ליצור שיעור',
	Assign: 'לקבוע',
	Home: 'לעמוד הראשי',
	'To cabinet': 'למשרד',
	'Create a homework': 'ליצור שיעורי בית',
	'Group nickname': 'שם הקבוצה',
	Month: 'חודש',
	January: 'ינואר',
	February: 'פברואר',
	March: 'מרץ',
	April: 'אפריל',
	May: 'מאי',
	June: 'יוני',
	July: 'יולי',
	August: 'אוגוסט',
	September: 'ספטמבר',
	October: 'אוקטובר',
	November: 'נובמבר',
	December: 'דצמבר',
	Overall: 'באופן כללי /בכלל',
	Active: 'פעילים',
	'Contract number': 'מספר חוזה',
	'For parents': 'להורים',
	'Choose lessons': 'לבחירת שיעור',
	Save: 'לקבוע',
	Close: 'לסגור',
	'Change birthday': 'לשנות תאריך לידה',
	Sent: 'נשלח',
	'Choose date': 'לבחור תאריך',
	'Include students': 'להוסיף תלמידים/להכניס תלמידים',
	'Add service': 'להוסיף שירות',
	'Create folder': 'ליצור תיקיה חדשה',
	Answer: 'תשובה',
	Price: 'מחיר',
	'Date of creating': 'תאריך יצור',
	unpaid: 'לא שולם',
	Paid: 'שולם',
	'Excluded students': 'תלמידים לא מחוברים',
	'Selected groups': 'הקבוצות שנבחרו',
	Monday: 'יום ראשון',
	Tuesday: 'יום שני',
	Wensday: 'יום שלישי',
	Thusday: 'יום רביעי',
	Friday: 'יום חמישי',
	Saturday: 'יום שישי',
	Sunday: 'שבת',
	Mo: 'א',
	Tu: 'ב',
	We: 'ג',
	Th: 'ד',
	Fr: 'ה',
	Sa: 'ו',
	Su: 'ש',
	End: 'סוף',
	'Add discount': 'להוסיף הנחה',
	Edit: 'עריכה',
	'Parent found': 'ההורה נמצא',
	'Changes saved': 'השינויים נשמרו',
	'The passwords of the parent and the student should not coincide':
		'הסיסמה של הורה ותלמיד חייבת להיות שונה',
	'Your region`s price is set to': 'המחיר לפי מיקומך נקבע',
	'and the holder`s reward is': 'בונוס בעל הזכויות',
	'regardless of the set price':
		'1-ללא קשר למחיר הקבוע         2- לא תלוי במחיר הקבוע',
	'The given password is not unique for this email':
		'הסיסמה לא בלעדית לדואר אלקטרוני הזה',
	'Enter a valid email address.': 'הכניסו דואר אלקטרוני נכון',
	'The phone number entered is not valid': 'המספר שהוכנס אינו בתוקף',
	Holiday: 'חגים',
	'Working days': 'ימי חול',
	Street: 'רחוב',
	'Location name': 'מקום השיעור',
	District: 'שכונה',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic  trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading':
		"מתמטיקה מנטלית –זאת שיטה שמפתחת במהירות את היכולות של חשיבה ואינטליגנציה של ילדים בגילאים בין 5 ל 14 שנים. מהלך למידה מתבצע בעזרת חשבונייה הסינית 'אבאקוס'. מתמטיקה מנטלית מאמנת בו זמנית הן המיספרה השמאלית והן המיספרה הימנית של המח, משפרת זיכרון ויזואלי, ריכוז, קראטיביות, חשיבה מפושטת, דמיון ונטייה של ילדים לקריאה מהירה מדי.",
	'Field required': 'שדה חובה',
	'Type of legal activity': 'סוג פעילות',
	'Legal address': 'כתובת חוקית',
	'Registration number': 'מספר רישום',
	'Add Group': 'להוסיף קבוצה',
	'Add Student': 'להוסיף תלמיד',
	Signin: 'כניסה',
	'Bonus days': 'ימי בונוס',
	'Bonus weeks': 'שבועות בונוס',
	'Are you sure you want to delete?': '?ת/אתה בטוח/ה שברצונך למחוק',
	Delete: 'מחק',
	Days: 'ימים',
	Confirm: 'לאשר',
	Cancel: 'ביטול',
	Week: 'שבוע',
	Weeks: 'שבועות',
	'Group age name': 'קבוצת גיל',
	'Set bonus days': 'לעדכן ימי בונוס',
	'Default language': 'שפה לא נכונה',
	'With english': 'עם אנגלית',
	'Without english': 'ללא אנגלית',
	'Paid status': 'מצב תשלום',
	'Not paid': 'לא שולם',
	Turnover: 'חזרה  סיבוב',
	Block: 'חסימה',
	Blocked: 'חסומים',
	'On holidays': 'בחופש',
	Language: 'שפה',
	Discounts: 'הנחות',
	Message: 'הודעות',
	Subject: 'נושא',
	Homework: 'Homework',
	'Homework ': 'שיעורי בית',
	'Homework on': 'שיעורי בית',
	'You need to complete the exercises': 'את/ה חייב/ת להשלים תרגילים',
	Homework: 'שיעורי בית',
	'Invoice for': 'לתשלום',
	Account: 'חשבון',
	Supplier: 'ספק',
	Buyer: 'קונה',
	'Bank code': 'קוד בנק',
	'Type phone number or email': 'הכנס מספר טלפון/כתובת דואר אלקטרוני',
	'Type password': 'הכנס סיסמה',
	'Forgot password': ' שכחתי סיסמה',
	'Type your email': 'הכנס כתובת דואר אלקטרוני',
	Send: 'שלח',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		"במידה ונרשמת/ה תקבל' הודאה לדואר אלקטרוני עם הדרכה לכניסה לחשבון שלך",
	'Back to the sign in': 'חזור לעמוד ראשי',
	'Password or login is not correct': 'שם משתמש או סיסמה אינם נכונים',
	'Password recovery': 'שחזור סיסמה',
	'Type your new password here': 'הכנס סיסמה חדשה',
	'Set new password': 'עדכן סיסמה חדשה',
	'Learn more': 'ללמוד יותר',
	'About Us': 'אודות',
	Company: 'חברה',
	Jobs: 'עבודה',
	Press: 'עיתונות',
	'Terms of Use': 'תנאי שימוש',
	'Privacy Policy': 'שמירת פרטיות',
	'Need help?': 'זקוק לעזרא',
	'Contact us': 'צור קשר',
	'Become franchise': 'פרנשיזה',
	'Select language': 'בחירת שפה',
	English: 'אנגלית',
	Russian: 'רוסית',
	New: 'Nowy',
	Azerbaijani: 'חָדָשׁ',
	Ukrainian: 'אוקראינית',
	Management: 'ניהול',
	'Master Franchise': 'מאסטר',
	Franchise: 'זיכיון',
	Teachers: 'מורים',
	Groups: 'קבוצות',
	Students: 'תלמידים',
	Student: 'תלמיד',
	Parents: 'הורים',
	Profile: 'פרופיל',
	'My profile': 'פרופיל שלי',
	Finance: 'מימון',
	Reports: 'דיווח',
	Report: 'דיווח',
	Upload: 'לעלות',
	List: 'רשימה',
	Payments: 'תשלומים',
	Documents: 'מסמכים',
	Lessons: 'שיעורים',
	Materials: 'חומרים',
	Shop: 'חנות',
	Statistics: 'סטטיסטיקה',
	Settings: 'הגדרות',
	Pages: 'עמודים',
	Logout: 'יציאה',
	Dashboard: 'עמוד אישי',
	'Access denied': 'נדחה',
	Create: 'ליצור',
	Download: 'הורדה/ להוריד',
	Status: 'סטטוס',
	'Payment Date': 'תאריך תשלום',
	'Payment Amount': 'סכום התשלום',
	'Start time': 'שעת תחילת לימודים',
	'Group age': 'קבוצת גיל',
	Junior: 'קטנים',
	Average: 'בינוניים',
	Class: 'כיתה',
	Older: 'גדולים/בוגרים',
	Region: 'מיקום',
	Group: 'קבוצה',
	Person: 'אדם',
	Finances: 'כספים/מימון',
	Actions: 'פעולות',
	'Send invoice': 'לשלוח חשבונית',
	'Download invoice': 'להוריד חשבון',
	'Send email': 'לשלוח דואר אלקטרוני',
	'Create Student': 'ליצור תלמיד / להוסיף תלמיד',
	'The beginning of holidays': 'תחילת חגים',
	'Start of study': 'תחילת לימודים',
	'Group name': 'שם הקבוצה',
	'Group address': 'כתובת הקבוצה',
	'Group teacher': 'מורים הקבוצה',
	'Group students': 'תלמידי קבוצה',
	'Group statistics': 'סטטיסטיקה של הקבוצה',
	Search: 'חיפוש',
	'General information': 'מידע כללי',
	'Phone number': 'מספר טלפון',
	'First name': 'שם',
	Surname: 'שם האב',
	'Last name': 'שם משפחה',
	'Date of birth': 'תאריך לידה',
	Password: 'סיסמה',
	'Additional information': 'מידע נוסף',
	'Id code': 'קוד זיהוי',
	Passport: 'מספר תעודת זהות',
	'Without email newsletter': 'ללא הודעות אלקטרוניות',
	'With email newsletter': 'עם הודעות אלקטרוניות',
	'Financial information': 'מידע כספי',
	Royalty: 'תמלוגים',
	'PR contribution': 'תרומות יחסי ציבור',
	Currency: 'מטבע חוץ',
	Comment: 'תגובה',
	Invoice: 'חשבונית',
	Bills: 'שטרות',
	Acts: 'מעשים',
	Scan: 'סריקה',
	Level: '‎שלב',
	'Action with numbers': 'מספר פעולות',
	'Action with number': 'כמות הפעולות',
	'Number of expressions': 'מספר  תרגילים',
	'Number of expression': 'כמות התרגילים',
	'Imaginary abacus': 'חשבונייה מדומה',
	'Period repor': 'תקופת דיווח',
	City: 'עיר',
	'Full name franchise': 'שם ושם משפחה מלא של בעל זיכיון',
	'Students active': 'סטודנטים פעילים',
	'Сost of education': 'מחיר המנוי',
	'Turnover franchise': 'מחזור',
	'Discount sum': "הנחה סה'כ",
	Proprietor: 'הבעלים',
	'Additional products and services': 'מוצרים ושירותים נוספים',
	'Full name student': 'שם מלא של התלמיד',
	'Period of study': 'תקופת הלימודים',
	'Bonus-days': 'ימי בונוס',
	'Amount of days': 'מספר ימים',
	'Total days': "סה'כ ימים",
	'Language of instruction': 'שפת הלמידה',
	Teacher: 'מורים',
	Discount: 'הנחה',
	Remuneration: 'שכר',
	Goods: 'מוצרים',
	'Date of creation': 'תאריך יצירה',
	'Date of payment': 'תאריך תשלום',
	'Goods (works, services)': 'שירותים',
	Quantity: 'כמות',
	Units: 'יחידות',
	Amount: 'כמות',
	Sum: 'סכום',
	'Sum Sub': 'המהיר ועצבני',
	Financial: 'כלכלי',
	Additional: 'נוסף / נוספת',
	General: 'כללי',
	Total: "סה'כ",
	Save: 'שמור',
	'Including with': 'כולל',
	'Training materials': 'חומרי לימוד',
	'Learning contract': 'חוזה לימודים',
	Games: 'משחקים',
	'NUMBER OF 11 TO 120': 'מספרים מ 11 עד 120',
	Complexity: '‎רמת קושי',
	Start: 'התחלה',
	'Speedy numbers': 'המהיר ועצבני',
	Anzan: 'אנזאן',
	'Abacus is random': 'אבאקוס רנדום',
	Multiplication: 'כפל',
	Division: 'חילוק',
	Abacus: '  אבאקוס',
	'Abacus Random': 'אבקוס אקראי',
	'Multiplying by 20': 'כפל עד 20',
	Squared: 'ורש בריבוע',
	'Division to 20': 'חילוק עד 20',
	Speed: 'מהירות',
	Repeat: 'חזרה',
	'Game type': 'סוג המשחק',
	'Digit type': 'סוגי המספרים',
	Digit: 'מספר',
	Time: '‎זמן',
	Second: 'שניות',
	'Calculation method': 'שיטת חישוב',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		'רק מספרים שליליים המתחילים מ 99,999,999 .בהתאם לדרגת הקושי של תרגיל',
	'Only subtraction': 'חיסור בלבד',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'רק מספרים חיוביים המתחילים מאפס, חיבור בלבד. לדוגמה :+1, +4, +8……',
	'Only add': 'חיבור בלבד',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		'המספרים מופיעים בצורה אקראית. לדוגמה :+3, -5,-1, +9, -2',
	'Random numbers': 'מספרים  אקראיים',
	'CHOOSE COMPLEXITY': 'בחר דרגת הקושי',
	'AMOUNT OF ACTIONS WITH NUMBER': 'מספר פעולות עם מספרים',
	family: 'משפחה',
	'big  friends': 'חברים גדולים',
	'small friends': 'חברים קטנים',
	elementary: 'חברים',
	Sound: 'שמע',
	'Congratulations! You did it! Now you can go to the following exercises':
		'מזל טוב! הצלחתה! אתה יכול להמשיך!',
	'RIGHT. ANSWER': 'נכון',
	CORRECT: 'נכון',
	'NOT CORRECT': 'לא נכון',
	'Try again': 'נסה שוב',
	expression: 'תרגיל',
	next: 'הבאה',
	Next: 'הבאה',
	Previous: 'קודם',
	Loading: 'מעלה',
	back: 'חזרה',
	Back: 'חזרה',
	ANSWER: 'תשובה',
	Lesson: 'שיעור',
	'History statistics': 'היסטוריה סטטיסטית',
	Open: 'לפתוח',
	'Game statistics per day': 'סטטיסטיקה של משחק ימית',
	'Total played games': "סה'כ משחקים שהסתיימו",
	'Total correct answers': "סה'כ תשובות נכונות",
	'Total played': "סה'כ היו משחקים",
	Feedback: 'תגובות',
	'Leave a review': 'להשאיר תגובה',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'תשאירו תגובה או הודעה ואנחנו נשתדל להתייחס אליה',
	'Payment history': 'היסטוריית תשלומים',
	'Payment status': 'מצב תשלום',
	Pay: 'לשלם',
	Add: 'לְהוֹסִיף',
	'Add file': 'הוסף קובץ',
	Payer: 'משלם',
	'Getting a discount': 'לקבל הנחה',
	Training: 'תרגול / אימון',
	Tasks: 'משימה',
	'Current task': 'משימה נוכחית',
	'Only task': 'משימה',
	'Next tasks': 'משימה הבאה',
	'Online abacus': 'חשבונייה און ליין',
	'Base 50/100': 'בסיס 50/100',
	multiply_base: 'בסיס 50/100',
	'Multiplication table': 'לוח הכפל',
	МФО: 'בנק',
	divided: 'מחולקים',
	divider: 'מחלק',
	'Р/Р': 'מספר חשבון',
	'Do not show this instruction again': 'אל תציג הוראה זו שוב',
	'Instructions for homework': 'הוראות לשיעורי בית',
	Restore: 'לשחזר',
	Left: 'שמאלה',
	'Restore Hierarchy': 'שחזור היררכיה',
	total: 'סך הכל',
	active: 'פעיל',
	blocked: 'חסום',
	pageError: {
		'403': 'הגישה נדחתה.',
		'404': 'דף זה אינו קיים. נסה שוב.',
		'500': 'השרת לא מגיב. נסה שוב.',
	},
	error: {
		'Account deactivated': 'חשבונך בוטל.',
	},
	modalNewVersion: {
		text: 'אתה משתמש בגרסה מיושנת של האתר.\nהעדכון כבר זמין.',
		btn: 'רענן.',
	},
	games: {
		negativeNumbers: 'מספרים שליליים',

		pause: 'הפסקה',
		resume: 'להמשיך',
		columns: {
			name: 'עמודים',
			users: 'מספר השחקנים',
			user: 'נגן',
			userNames: 'שמות שחקנים',
		},
	},
	'Indigo-dollars': 'דולר אינדיגו',
	Balance: 'איזון שוטף',

	modalIndigoDollars: {
		submit: 'הגש',
		cancel: 'בטל',
		title: 'דולר אינדיגו',
		balance: 'איזון שוטף',
		amount: 'כמות',
		reason: 'פרשנות',
	},

	modalAddNotification: {
		title: 'הוסף הודעה',
		submit: 'הגש',
		cancel: 'בטל',
		empty: 'אין התראות',
	},

	modalTransactionsHistory: {
		title: 'היסטוריית תשלומים',
		type: {
			withdraw: 'מחיקה',
			deposit: 'חידוש',
		},
		empty: 'רשימת התשלומים ריקה.',
	},

	modalCopyHomework: {
		title: 'העתק שיעורי בית',
		label: 'בחר את התאריך בו ברצונך להעתיק את שיעורי הבית שלך',
		submit: 'עותק',
		cancel: 'בטל',
	},

	reportsPage: {
		history: {
			title: 'שנה את ההיסטוריה',
			empty: 'הרשימה ריקה',
			table: {
				date: 'שנה תאריך',
				field_name: 'פעולה',
				old_value: 'משמעות ישנה',
				new_value: 'ערך חדש',
				user: 'המשתמש שונה',
			},
		},
	},

	pageShop: {
		title: 'חנות שיפורים',
		description: 'בחנות תוכלו לקנות שיפורים שונים למראה האתר בדולרי אינדיגו',

		tabs: {
			all: 'כל השיפורים',
			purchased: 'נרכש',
		},

		item: {
			off_all: 'לא',

			status: {
				AVAILABLE: 'זמין',
				DEPRECATED: 'לא זמין',
				COMING_SOON: 'בקרוב',
			},
			is_activated: 'נבחר',
			set_active: 'בחר',
			unset_active: 'השבת',
			preview: 'תראה',
			is_free: 'בחינם',
			buy: 'קנה',
			bought: 'נקנה',
			purchased: 'נרכש',
		},
		empty: {
			all: 'אין שיפורים זמינים',
			purchased: 'לא נרכשו שדרוגים',
		},

		toast: {
			error: 'אירעה שגיאה',
			notEnoughMoney: 'אין מספיק כספים',
			itemBought: 'שיפור שנרכש',
			itemActivated: 'שיפור מופעל',
			itemDeactivated: 'משופר מבוטל',
		},
		confirmPurchase: {
			title: 'אישור רכישה',
			message: 'האם אתה בטוח שברצונך לקנות פריט זה?',
			confirm: 'כן, קנה',
			cancel: 'ביטול',
		},
	},

	demo: {
		title: 'שיעור הדגמה חינם',
		tutorial: {
			title: 'מדריך הוראות',
			text:
				'תיאור הפעולותברוך הבא לשיעור ההדגמה המקוון בנושא אינדיגו מנטאלי חשבון.\n אינדיגו מנטלית הוא בית הספר הטוב ביותר בחשבון נפשי בעולם, ניסיון רב השנים של החברה והצלחת תלמידים רבים ברחבי העולם באולימפיאדה מוכיחים כי טכניקה זו היא יעילה, ייחודית, עובדת. הורים רבים כבר משוכנעים במתודולוגיה, שמחים על הצלחותיהם של ילדיהם, לא רק בחשבון, אלא במדעים אחרים, במוזיקה, בספורט ומציינים קפיצה גדולה ביכולות האינטלקטואליות של ילדם.\n חשבון נפשי היא שיטה יפנית לספירה מהירה דרך הפה, המפתחת במהירות את היכולות הנפשיות והאינטליגנציה של ילד. תהליך הלמידה מתרחש בחשבונות יפניים מיוחדים אבקוס (סורובן). אריתמטיקה נפשית מכשירה את חצי הכדור השמאלי והימני של המוח בו זמנית, ומשפרת את הזיכרון הויזואלי, ריכוז הקשב, אוריינטציה יצירתית, חשיבה דמיונית של ילדים.\n בואו נתחיל ללמוד חשבון נפשי, לשם כך, לחץ על כפתור &quot;הפעל&quot; בסרטון למטה, האזן וחזור.',
		},
	},

	disableStudent: {
		btn: 'Disable student',
		list: 'Students without deactivation date',
		modal: {
			title: 'Disableing a student',
			description: 'You are about to disable the student',
			fieldLabel: 'Select month',
			btnSubmit: 'Disable',
			btnCancel: 'Cancel',
		},
	},
}
